/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Un único punto de datos para la gráfica de goles (Minuto, Puntuación).
 */
export interface GoalTimePoint { 
    minute: number;
    second: number;
    score: number;
}

